import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  searchText:any;
  name:any;
  constructor() { }

  ngOnInit(): void {
    this. name = localStorage.getItem('name');
  this.name =this. name?.replace(/^"(.*)"$/, '$1');
  }

}
